<template>
  <LayoutSection
    :id="id"
    :title="sectionTitle"
    padding
    class="paragraph--padded"
  >
    <SearchTeaserList
      v-slot="{ hit }"
      endpoint="events"
      :size="count"
      :reference-facets="{
        organization: eventOrganizations,
      }"
      :query-filters="{
        tag: eventTags,
        topic: eventTopics,
      }"
      list-class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 mt-30 mb-10 [&>li]:pb-20 [&>li]:row-span-9 [&>li]:grid [&>li]:grid-rows-subgrid [&>li]:grid-cols-1"
      :show-more="{
        route: 'event-calendar-overview',
        label: $texts('allEvents', 'Alle Veranstaltungen'),
      }"
      :no-results-text="
        $texts(
          'eventListList.noEventsFoundWithSelectedFilters',
          'Es wurden keine Veranstaltungen mit den ausgewählten Filtern gefunden.',
        )
      "
    >
      <EventTeaser v-bind="hit" />
    </SearchTeaserList>
  </LayoutSection>
</template>

<script setup lang="ts">
import type { ParagraphEventListFragment } from '#graphql-operations'
import { slugify } from '~/helpers/slugify'

defineBlokkli({
  bundle: 'event_list',
  chunkName: 'rare',
  globalOptions: ['showInToc', 'bkVisibleLanguages'],
})

const { $texts } = useNuxtApp()

const props = defineProps<{
  title?: ParagraphEventListFragment['title']
  count?: ParagraphEventListFragment['count']
  eventTopics?: ParagraphEventListFragment['eventTopics']
  eventTags?: ParagraphEventListFragment['eventTags']
  eventOrganizations?: ParagraphEventListFragment['eventOrganizations']
}>()

const sectionTitle = computed(
  () => props.title || $texts('events', 'Veranstaltungen'),
)

const id = computed(() => slugify(sectionTitle.value))

defineOptions({
  name: 'ParagraphEventList',
})
</script>
